import React, { Component } from 'react';
import Leftbar from '../components/Leftbar';

class Projects extends Component {
    render() {
        let data = [
            {
                titulo: "MX Covid-19", 
                descripcion: "Mexican COVID-19 Tracker",
                link: "https://jebusdoodles.github.io/mx-covid19/",
                img: "./site-01.png"
            },
            {
                titulo: "Ingeniera+diseño", 
                descripcion: "Landing page built on React JS",
                link: "https://ingenieriaid.mx/",
                img: "./site-02.png"
            }
        ]
        return (
            <>
                <Leftbar />
                <div className="container">
                    <div className="row main-section justify-content-md-center align-items-center">
                        <h1 className="subtitle">Online</h1>
                        {
                            data.map(c =>
                                <div className="col-md-4">
                                    <div className="card">
                                        <img src={c.img} className="card-img-top" alt="..." />
                                        <div className="card-body text-center">
                                            <h5 className="card-title">{c.titulo}</h5>
                                            <p className="card-text">{c.descripcion}</p>
                                            <a className="btn-link" href={c.link}>Go to site</a>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default Projects;